import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { runEscStep } from "@/lib/escBack";

// Global keyboard shortcuts:
//  Alt+S -> Sales bill create screen
//  Alt+P -> Purchase bill create screen
//  Ctrl+Enter -> save the current entry (submits the active form)
export function useGlobalShortcuts() {
  const navigate = useNavigate();
  useEffect(() => {
    const onKey = (e) => {
      if (e.altKey && !e.ctrlKey && !e.shiftKey && !e.metaKey) {
        const k = (e.key || "").toLowerCase();
        if (k === "s") { e.preventDefault(); e.stopPropagation(); navigate("/invoices/create"); return; }
        if (k === "p") {
          if (window.location.pathname.startsWith("/ledger-views")) return;
          e.preventDefault(); e.stopPropagation(); navigate("/purchases?new=1"); return;
        }
      }
      if (e.ctrlKey && !e.altKey && e.key === "Enter") {
        const el = document.activeElement;
        const form = (el && el.closest && el.closest("form"))
          || document.querySelector('[role="dialog"] form')
          || document.querySelector("main form");
        if (form) {
          e.preventDefault(); e.stopPropagation();
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
          return;
        }
        const btn = document.querySelector("[data-ctrl-save]");
        if (btn) { e.preventDefault(); e.stopPropagation(); btn.click(); }
      }
    };
    window.addEventListener("keydown", onKey, true);

    // Esc = go back ONE step (Tally-style): first close any open drill-down
    // on the current screen (via escBack handlers), else go to the previous
    // route — never jump multiple screens back.
    const onEsc = (e) => {
      if (e.key !== "Escape") return;
      const t = e.target || {};
      const tag = (t.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || tag === "select" || t.isContentEditable) { if (t.blur) t.blur(); return; }
      // Defer: let every screen-specific handler run first; only go back
      // if none of them consumed the key.
      setTimeout(() => {
        if (e.defaultPrevented) return;
        if (document.querySelector('[role="dialog"], [data-radix-popper-content-wrapper]')) return;
        if (runEscStep()) return; // one internal step back (detail → list)
        if (window.location.pathname === "/dashboard") return;
        const idx = (window.history.state && window.history.state.idx) || 0;
        if (idx > 0) navigate(-1); else navigate("/dashboard");
      }, 0);
    };
    window.addEventListener("keydown", onEsc);
    return () => {
      window.removeEventListener("keydown", onKey, true);
      window.removeEventListener("keydown", onEsc);
    };
  }, [navigate]);
}
